import { TextField } from "@mui/material";
import { TimePicker } from "@mui/x-date-pickers";
import { useSession } from "app/hooks/useSession";
import { getUserDateTimePreferences, pickerDateToTimeValue, timeValueToPickerDate, toDateFnsPickerFormat } from "../services/dateTimePreferences";
import { SharedFieldInputProps } from "./types";

export function TimeFieldInput({
    value,
    onChange,
    error = false,
    helperText,
    fullWidth = true,
    size = "small",
    disabled = false,
}: SharedFieldInputProps<string | null>) {
    const { data: user } = useSession();
    const preferences = getUserDateTimePreferences(user);

    return (
        <TimePicker
            value={timeValueToPickerDate(value)}
            inputFormat={toDateFnsPickerFormat(preferences.timeFormat)}
            onChange={(date) => {
                const normalizedDate = date as Date | null;
                onChange(pickerDateToTimeValue(normalizedDate));
            }}
            disabled={disabled}
            renderInput={(params) => (
                <TextField
                    {...params}
                    fullWidth={fullWidth}
                    size={size}
                    InputLabelProps={{ shrink: true }}
                    error={error}
                    helperText={helperText}
                />
            )}
        />
    );
}
